<template>
  <widget-temp widgetTitle="Danh sách lô hàng" widgetName="BigpackageSummary" v-bind:widgetId="1">
    <template slot="widget-content">
      <div class="performance-block">
        <div class="row">
           <bigpackage-list :dashboard_pagination="pagination"></bigpackage-list>
        </div>
      </div>
    </template>
  </widget-temp>
</template>

<script>
import BigPackageList from "@/views/BigPackage/list";
import configs from "@/configs";
export default {
    name: "bigpackage-summary",
    components: {
        "bigpackage-list": BigPackageList
    },
    data() {
        return {
            pagination: { ...configs.PAGINATION, sortBy: ["ImDate"], sortDesc: [false]},
        }
    }
};
</script>

<style  lang="scss" scoped>
@media (max-width: 992px) {
    .group-box-mb {
        display: block;
    }
    .group-box {
        display: none;
    }
}
@media (max-width: 686px) {
    .widget-block .content-widget .performance-block .title-stt {
        font-size: 14px;
        line-height: 1.2; }
    .widget-block .content-widget .performance-block .num {
        font-size: 28px; } }
    @media (max-width: 500px) {
    .widget-block .content-widget .performance-block .col.col-4, .widget-block .content-widget .performance-block .col.col-8 {
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%; }
    .widget-block .content-widget .performance-block .div-table.height-2 {
        height: 150px !important; } }
.widget-block .content-widget .stt-block{margin-bottom:10px;}
.performance-block .col > .col{padding: 0;}
.performance-block .col > .col > .col{padding: 0;}
.performance-block .row{margin: 0px;}
.performance-block .col{padding:0px;}
</style>